export enum PlanServiceAreaOverrideRuleStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export const PLAN_SERVICE_AREA_OVERRIDE_TEMPLATE = 'UPSERT_RULE' as const
export type PlanServiceAreaOverrideRuleTemplateKey =
  typeof PLAN_SERVICE_AREA_OVERRIDE_TEMPLATE
